import React from "react";
import { BaseHTMLAttributes } from "react";

export const EntitySeparator = ({
  children,
  ...rest
}: BaseHTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      css={`
        grid-column: 1 / -1;
      `}
      {...rest}
    >
      {children}
    </div>
  );
};
